import { capitalize, compact } from 'lodash';

import { MODE_AIR, MODE_RAIL, MODE_ROAD, MODE_WATER, VEHICLE_TYPES } from '@/lib/constants';
import { EmissionsModeBreakdown, RadialChartData } from '@/types';
import { getTransportColor, getTransportTextColor } from '@/utils/helpers/get-transport-color';

const EMISSION_MODES: { mode: keyof EmissionsModeBreakdown; alternativeLabel?: string }[] = [
  { mode: MODE_ROAD },
  { mode: MODE_AIR },
  { mode: MODE_WATER, alternativeLabel: capitalize(VEHICLE_TYPES.VESSEL) },
  { mode: MODE_RAIL },
];

export const transformModeBreakdownToRadialData = (data: EmissionsModeBreakdown): RadialChartData[] => {
  const output = EMISSION_MODES.map(({ mode, alternativeLabel }): RadialChartData | null => {
    const emissionValue = data?.[mode] as number;
    if (!emissionValue) return null;

    const color = getTransportColor(mode);
    const textColor = getTransportTextColor(mode);

    return {
      name: `${capitalize(alternativeLabel || mode)} emissions`,
      value: emissionValue,
      percent: 0,
      color,
      textColor,
    };
  });

  const rows = compact(output);
  const totalValue = rows.reduce((a, b) => a + b.value, 0);

  return rows.map((row) => {
    return {
      ...row,
      percent: Math.round((row.value / totalValue) * 100),
    };
  });
};
